// extracted by mini-css-extract-plugin
export default {"lastScreenSection":"LastScreen_lastScreenSection__Fb8wq"};